import PropTypes from 'prop-types'
import React from 'react'
import PostRepository from '../../src/repositories/PostRepository'
import { getFullUrlFromReq } from '../../src/common/serverUtils'
import { generateSeoData } from '../../src/common/nextSeoUtils'
import Layout from '../../src/components/layouts'
import PressPostPage from '../../src/components/pages/PressPost'
import NewsRoomPageLayout from '../../src/components/shared/NewsRoomLayout'
import PostLayout from '../../src/components/shared/PostLayout'
import logger from '../../src/common/logger'
import CustomJsonLd from '../../src/components/shared/CustomJsonLd'
import { jsonLdData } from '../../src/common/constants/jsonLd'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

export async function getServerSideProps({ params, preview, req }) {
  let item

  try {
    item = await PostRepository.getInstance().getBySlug(params.pid, {}, preview)
  } catch (error) {
    logger.error(`NewsRoom page: failed to get serverside props`, {
      pid: params?.pid,
      preview,
      error,
    })

    return {
      notFound: true,
    }
  }

  const validCategories = ['recent-news', 'press-releases']

  if (!item || !validCategories.includes(item.category.slug)) {
    return {
      notFound: true,
    }
  }

  const pagePid = ['newsroom', params.pid]

  const { canonicalUrl } = getFullUrlFromReq(req, pagePid)
  const seoData = item?.key
    ? generateSeoData({
        title: item.metaTitle,
        description: item.metaDescription,
        url: canonicalUrl,
        lastUpdate: item.updatedAt,
        follow: item.follow,
        index: item.index,
        images: [
          {
            url: item.image,
            width: 660,
            height: 230,
            alt: item.title,
          },
        ],
      })
    : {}

  return {
    props: {
      item: item || null,
      seoData,
      pid: params.pid,
    },
  }
}

const Post = ({ item, seoData, pid }) => {
  const { category, title } = item

  return (
    <Layout footerClassName="max-w-1400">
      <WithSeoOverrides {...seoData} />
      <CustomJsonLd
        id={'webPage'}
        data={jsonLdData(
          seoData?.title,
          seoData?.description,
          `/newsroom/${pid}/`
        )}
      />
      <NewsRoomPageLayout category={category} title={title}>
        {item.category.slug === 'press-releases' ? (
          <PressPostPage post={item} />
        ) : (
          <div className="max-w-2xl px-6 text-sm text-gray-500 sm:m-auto lg:px-0">
            <PostLayout post={item} type="newsroom" />
          </div>
        )}
      </NewsRoomPageLayout>
    </Layout>
  )
}

Post.propTypes = {
  item: PropTypes.object.isRequired,
  seoData: PropTypes.object.isRequired,
  pid: PropTypes.string,
}

export default Post
